import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ChipsData } from "../interfaces/customers.model";

@Injectable({ providedIn: 'root' })
export class ChipDataService {
  constructor(private http: HttpClient) {}

  getChipsData(): Observable<ChipsData> {
    return this.http.get<ChipsData>('api/clienti/pulsantiera');
  }
}